import React, { useState } from 'react';
import { api } from '../utils/api';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const result = await api.submitContact(formData);
      if (result.success) {
        alert(result.message || 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        alert(result.message || 'Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      alert('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
    }
    
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
    color: 'var(--white)',
    padding: '60px 0',
    textAlign: 'center'
  };

  const contentStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '60px',
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '60px 20px'
  };

  const cardStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '32px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
  };

  const contactItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '16px',
    background: 'var(--light-blue)',
    borderRadius: '8px',
    marginBottom: '16px'
  };

  const iconStyle = {
    fontSize: '24px',
    width: '40px',
    textAlign: 'center'
  };

  return (
    <div>
      {/* Header */}
      <section style={headerStyle}>
        <div className="container">
          <h1 style={{ fontSize: '36px', marginBottom: '16px', fontFamily: 'Comfortaa, cursive' }}>
            İletişim
          </h1>
          <p style={{ fontSize: '18px', opacity: 0.9 }}>
            Bizimle iletişime geçin, sorularınızı yanıtlayalım
          </p>
        </div>
      </section>

      <div style={window.innerWidth > 768 ? contentStyle : { maxWidth: '600px', margin: '0 auto', padding: '60px 20px' }}>
        {/* Contact Form */}
        <div style={cardStyle}>
          <h2 style={{ 
            fontSize: '24px', 
            marginBottom: '24px', 
            color: 'var(--navy-blue)',
            fontFamily: 'Comfortaa, cursive'
          }}>
            Mesaj Gönder
          </h2>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Adınız Soyadınız *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                required
                placeholder="Örn: Ahmet Yılmaz"
              />
            </div>

            <div className="form-group">
              <label className="form-label">E-posta Adresiniz *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                required
                placeholder="Örn: ahmet@email.com"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Telefon Numaranız</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
                placeholder="Örn: 0532 123 45 67"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Konu *</label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="form-select"
                required
              >
                <option value="">Konu Seçin</option>
                <option value="genel">Genel Bilgi</option>
                <option value="firma-ekleme">Firma Ekleme</option>
                <option value="teknik-destek">Teknik Destek</option>
                <option value="sikayet">Şikayet</option>
                <option value="oneri">Öneri</option>
                <option value="is-birligi">İş Birliği</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Mesajınız *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="form-textarea"
                required
                placeholder="Mesajınızı buraya yazın..."
                style={{ minHeight: '150px' }}
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
              style={{ width: '100%', fontSize: '16px' }}
            >
              {loading ? 'Gönderiliyor...' : 'Mesaj Gönder'}
            </button>
          </form>
        </div>

        {/* Contact Information */}
        <div style={cardStyle}>
          <h2 style={{ 
            fontSize: '24px', 
            marginBottom: '24px', 
            color: 'var(--navy-blue)',
            fontFamily: 'Comfortaa, cursive'
          }}>
            İletişim Bilgileri
          </h2>

          <div style={contactItemStyle}>
            <span style={iconStyle}>📧</span>
            <div>
              <strong>E-posta</strong><br/>
              <a href="mailto:info@kolayservis.com" style={{ color: 'var(--navy-blue)' }}>
                info@kolayservis.com
              </a>
            </div>
          </div>

          <div style={contactItemStyle}>
            <span style={iconStyle}>📍</span>
            <div>
              <strong>Adres</strong><br/>
              İstanbul, Türkiye
            </div>
          </div>

          <div style={contactItemStyle}>
            <span style={iconStyle}>🕒</span>
            <div>
              <strong>Çalışma Saatleri</strong><br/>
              Pazartesi - Cuma: 09:00 - 18:00<br/>
              Hafta Sonu: Kapalı
            </div>
          </div>

          <div style={{ marginTop: '32px', padding: '20px', background: 'var(--light-blue)', borderRadius: '8px' }}>
            <h3 style={{ 
              fontSize: '18px', 
              marginBottom: '12px', 
              color: 'var(--navy-blue)',
              fontFamily: 'Comfortaa, cursive'
            }}>
              Hızlı Yanıt
            </h3>
            <p style={{ fontSize: '14px', color: 'var(--gray-600)', lineHeight: '1.6' }}>
              Mesajlarınıza genellikle 24 saat içinde yanıt veriyoruz.
            </p>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div style={{ background: 'var(--gray-100)', padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ 
            fontSize: '32px', 
            textAlign: 'center', 
            marginBottom: '40px', 
            color: 'var(--navy-blue)',
            fontFamily: 'Comfortaa, cursive'
          }}>
            Sık Sorulan Sorular
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '24px',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            <div style={cardStyle}>
              <h3 style={{ fontSize: '18px', marginBottom: '12px', color: 'var(--navy-blue)' }}>
                Firma ekleme ücretsiz mi?
              </h3>
              <p style={{ color: 'var(--gray-600)', fontSize: '14px' }}>
                Evet, firmalarını rehberimize eklemek tamamen ücretsizdir. 
                Sadece onay sürecinden geçmesi gerekmektedir.
              </p>
            </div>

            <div style={cardStyle}>
              <h3 style={{ fontSize: '18px', marginBottom: '12px', color: 'var(--navy-blue)' }}>
                Onay süreci ne kadar sürer?
              </h3>
              <p style={{ color: 'var(--gray-600)', fontSize: '14px' }}>
                Firma onay süreci genellikle 1-2 iş günü sürmektedir. 
                Eksik bilgi durumunda size ulaşırız.
              </p>
            </div>

            <div style={cardStyle}>
              <h3 style={{ fontSize: '18px', marginBottom: '12px', color: 'var(--navy-blue)' }}>
                Firma bilgilerimi nasıl güncellerim?
              </h3>
              <p style={{ color: 'var(--gray-600)', fontSize: '14px' }}>
                Firma bilgilerinizi güncellemek için bizimle iletişime geçin. 
                Gerekli değişiklikleri hızlıca yapacağız.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;